import React, { useRef } from "react";

import { useTheme } from "../../../../context/theme";
import { Box } from "../../../layout";

type Props = {
  searchValue: string;
  autoFocus?: boolean;
  onChangeSearch: (event: React.FormEvent<HTMLInputElement>) => void;
};

export default function SearchInput({
  searchValue,
  autoFocus,
  onChangeSearch
}: Props) {
  const theme = useTheme();
  const inputRef = useRef<HTMLInputElement>(null);

  const onClick = () => {
    inputRef.current!.focus();
  };

  return (
    <Box
      ref={inputRef}
      autoFocus={autoFocus}
      onClick={onClick}
      component="input"
      placeholder="Search..."
      onChange={onChangeSearch}
      value={searchValue}
      width="100%"
      height="38px"
      paddingX="12"
      paddingY="12"
      backgroundColor={theme.foreground}
      color={theme["neutral-high-content"]}
      placeholderStyles={{ color: theme["neutral-medium-content"] }}
      borderTopLeftRadius="small"
      borderTopRightRadius="small"
      borderWidth="none"
      borderBottomWidth="xxxsmall"
      borderColor={theme["neutral-high-content"]}
      focusStyles={{
        outline: "0"
      }}
    />
  );
}
